export const HOURS_TABS = {
  KNOCKBOT: 'knockbot',
  OFFICE: 'office',
  TOURING: 'touring',
};

export const HOURS_TAB_LIST = [
  HOURS_TABS.OFFICE,
  HOURS_TABS.TOURING,
  HOURS_TABS.KNOCKBOT,
];

export const HOURS_TAB_LABELS = {
  [HOURS_TABS.KNOCKBOT]: 'Knockbot',
  [HOURS_TABS.OFFICE]: 'Office',
  [HOURS_TABS.TOURING]: 'Touring',
};

export const OFFICE_TOURING_SAME_LABEL =
  'Office and Touring hours are the same';

export const TAB_ICONS = {
  [HOURS_TABS.KNOCKBOT]: 'message-bubble-happy',
  [HOURS_TABS.OFFICE]: 'office-desk',
  [HOURS_TABS.TOURING]: 'calendar-empty',
};
